import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "cyvr_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("cyvr:open-cookie-settings", reopen);
    return () => window.removeEventListener("cyvr:open-cookie-settings", reopen);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, analytics: choice === "accept", ts: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 md:px-6 md:pb-6"
    >
      <div className="mx-auto max-w-3xl overflow-hidden rounded-2xl border border-white/10 bg-[#0a0e1a]/95 shadow-[0_0_40px_rgba(0,240,255,0.12)] backdrop-blur-xl">
        <div className="flex items-start gap-4 p-5 md:p-6">
          <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-cyber-cyan/30 bg-cyber-cyan/10 text-cyber-cyan">
            <Cookie className="h-5 w-5" />
          </div>
          <div className="flex-1">
            <p className="font-head text-sm font-bold text-white">Usamos cookies</p>
            <p className="mt-1.5 font-sans text-xs leading-relaxed text-white/60">
              Utilizamos cookies técnicas necesarias y cookies analíticas (Google Analytics) para
              medir el uso del sitio. Puedes aceptarlas o rechazar las no esenciales. Consulta nuestra{" "}
              <Link to="/cookies" className="text-cyber-cyan underline underline-offset-2" data-testid="cookie-policy-link">
                Política de Cookies
              </Link>.
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2.5">
              <button
                data-testid="cookie-accept-btn"
                onClick={() => decide("accept")}
                className="rounded-full bg-cyber-cyan px-5 py-2 font-mono-tech text-[11px] font-semibold uppercase tracking-widest text-[#05070f] transition-transform hover:scale-[1.03]"
              >
                Aceptar
              </button>
              <button
                data-testid="cookie-reject-btn"
                onClick={() => decide("reject")}
                className="rounded-full border border-white/15 px-5 py-2 font-mono-tech text-[11px] font-semibold uppercase tracking-widest text-white/70 transition-colors hover:border-white/40 hover:text-white"
              >
                Rechazar
              </button>
              <Link
                to="/cookies"
                data-testid="cookie-configure-btn"
                className="rounded-full px-4 py-2 font-mono-tech text-[11px] font-semibold uppercase tracking-widest text-white/50 transition-colors hover:text-cyber-cyan"
              >
                Configurar
              </Link>
            </div>
          </div>
          <button
            data-testid="cookie-close-btn"
            onClick={() => decide("reject")}
            aria-label="Cerrar"
            className="text-white/40 transition-colors hover:text-white"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
